/**
 * Org-wide event color defaults. Per-EventType colors live on the EventType
 * row itself (`colorBackground` / `colorRing` / `colorText` on
 * `EventTypeRecordSchema`). The default values for those columns at
 * org-bootstrap come from `DEFAULT_EVENT_TYPE_SEEDS` — see
 * `./event-type-seed.ts`.
 */

import {
	CONVERSATION_EVENT_TYPE_SEED,
	DEFAULT_EVENT_TYPE_SEEDS,
} from "./event-type-seed";

export interface EventTypeColor {
	background: string;
	ring: string;
	text: string;
}

export interface EventColors {
	defaultEventColor: string;
	documentStrokeColor: string;
}

export const DOCUMENT_EVENT_RING_COLOR = "#facc15";

/**
 * Per-slug color lookup — derived from `DEFAULT_EVENT_TYPE_SEEDS` so the
 * UI picker, the calendar legend, and the seed code never disagree.
 */
export const EVENT_TYPE_COLOR_DEFAULTS: Readonly<
	Record<string, EventTypeColor>
> = Object.freeze(
	Object.fromEntries(
		DEFAULT_EVENT_TYPE_SEEDS.map((seed) => [
			seed.slug,
			{
				background: seed.colorBackground,
				ring: seed.colorRing,
				text: seed.colorText,
			} satisfies EventTypeColor,
		])
	)
);

export function buildDefaultEventColors(): EventColors {
	// Use the conversation seed's background as the org-wide fallback —
	// matches the historical default and keeps colour continuity.
	return {
		defaultEventColor: CONVERSATION_EVENT_TYPE_SEED.colorBackground,
		documentStrokeColor: DOCUMENT_EVENT_RING_COLOR,
	};
}
